module.exports = __webpack_public_path__ + "img/logo.9343aa00.png";